import { render } from "./Adjustment.vue?vue&type=template&id=5965d1e2&scoped=true"
import script from "./Adjustment.vue?vue&type=script&lang=ts"
export * from "./Adjustment.vue?vue&type=script&lang=ts"

import "./Adjustment.vue?vue&type=style&index=0&id=5965d1e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5965d1e2"

export default script